import React, { useCallback } from "react";
import { history } from "../../store";
import Fab from "@mui/material/Fab";
import CreateIcon from "@mui/icons-material/Create";
import { route as ticketFormRoute } from "../TicketFormContainer/TicketFormContainer";
import { Zoom } from "@mui/material";

function TicketCreateButton() {
  const handleClick = useCallback(() => {
    history.push(ticketFormRoute);
  }, []);

  return (
    <Zoom appear in timeout={500}>
      <Fab
        onClick={handleClick}
        color="secondary"
        aria-label="Add"
        sx={{ m: 1, position: "fixed", right: "2rem", bottom: "5rem" }}
      >
        <CreateIcon />
      </Fab>
    </Zoom>
  );
}

export default TicketCreateButton;
